import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { InformacionService } from "../../../services/informacion.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
})
export class NavbarComponent {
  videoData: any = {};
  ruta: string = "/home";
  c: boolean = false;
  
  constructor(
    private _router: Router,
    public _is: InformacionService,
  ) {
    _router.events.subscribe((data: any) => (this.ruta = data.url)); 
  }

  navigateMipres() {
    window.open("https://mipres.siris.com.co/", "_blank");
}

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/shared/navbar/navbar.component.ts